var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71942 12.013C6.73895 12.013 5.12109 10.4045 5.12109 8.41471C5.12109 6.42494 6.73895 4.82568 8.71942 4.82568C10.6999 4.82568 12.3177 6.43424 12.3177 8.42401C12.3177 10.4138 10.6999 12.013 8.71942 12.013ZM8.71942 6.22038C7.51068 6.22038 6.51579 7.20597 6.51579 8.42401C6.51579 9.64205 7.50138 10.6276 8.71942 10.6276C9.93746 10.6276 10.923 9.64205 10.923 8.42401C10.923 7.20597 9.92816 6.22038 8.71942 6.22038Z",
    fill: "#A3FF12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7184 20C7.3423 20 5.9569 19.4793 4.87833 18.4472C2.13542 15.8066 -0.895731 11.5946 0.247923 6.58298C1.28 2.03626 5.25025 0 8.7184 0C8.7184 0 8.7184 0 8.7277 0C12.1959 0 16.1661 2.03626 17.1982 6.59228C18.3325 11.6039 15.3014 15.8066 12.5585 18.4472C11.4799 19.4793 10.0945 20 8.7184 20ZM8.7184 1.3947C6.01268 1.3947 2.53523 2.83589 1.61473 6.88982C0.610545 11.2692 3.36275 15.0442 5.85462 17.4338C7.46317 18.9865 9.98293 18.9865 11.5915 17.4338C14.0741 15.0442 16.8263 11.2692 15.8407 6.88982C14.9109 2.83589 11.4241 1.3947 8.7184 1.3947Z",
    fill: "#A3FF12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.49c214e31b461839b97e3749fe7bd313.svg";
export { ForwardRef as ReactComponent };